import { render } from "./TemplateBookRefund.vue?vue&type=template&id=36e030b1&scoped=true"
import script from "./TemplateBookRefund.vue?vue&type=script&lang=js"
export * from "./TemplateBookRefund.vue?vue&type=script&lang=js"

import "./TemplateBookRefund.vue?vue&type=style&index=0&id=36e030b1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36e030b1"

export default script